/** @format */

import React from 'react';

export const Card = props => {
    const {className, children} = props;
    return <div className={`${className} card-common-29me  bg-structure-lightest`}>{children}</div>;
};
